import styled from 'styled-components';

import { COLORS, BREAKPOINTS } from '~/src/common/theme';
import { getMediaQuery } from '~/src/common/theme/deprecated';

export const Container = styled.div`
  background: ${COLORS.NEUTRAL_WHITE};
`;

export const Title = styled.h1`
  margin: 0;
  padding: 24px 0 16px;

  font-size: 20px;
  font-weight: 700;
  pointer-events: none;

  span:last-child {
    &::before {
      content: '“';
    }

    &::after {
      content: '”';
    }
  }

  @media ${getMediaQuery(0, BREAKPOINTS.XL)} {
    padding: 8px 0;
  }
`;

export const Tabs = styled.div`
  display: flex;
  gap: 10px;
  padding: 0;
`;

export const Tab = styled.button<{ $active: boolean }>`
  display: flex;
  align-items: center;
  padding: 8px 24px;
  gap: 4px;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  border: 1.6px solid;
  border-radius: 4px;

  ${({ $active }) => `
    color: ${$active ? COLORS.NEUTRAL_WHITE : COLORS.ACTION_DEFAULT};
    background: ${$active ? COLORS.ACTION_DEFAULT : COLORS.NEUTRAL_WHITE};
    border-color: ${$active ? COLORS.NEUTRAL_WHITE : COLORS.ACTION_DEFAULT};
  `}

  &:disabled {
    opacity: 0.8;
    filter: grayscale(1);
    cursor: not-allowed;
  }
`;
